import {TTemplatePropertyRecord} from "../components/template-property-form/TemplatePropertyForm";

export type TFormError = {
    field: string,
    message: string,
}

export default class TemplatePropertyValidator {
    validate(templateProperty: TTemplatePropertyRecord): TFormError[] {
        const errors: TFormError[] = [];

        if (!this.assertStringPresence(templateProperty.name)) {
            errors.push({
                field: "name",
                message: "Name cannot be blank",
            });
        }

        if (templateProperty.reforecastStartMonthIndex < 0 || templateProperty.reforecastStartMonthIndex > 11) {
            errors.push({
                field: "reforecastStartMonthIndex",
                message: "Valid month is required",
            });
        }

        return errors;
    }

    private assertStringPresence(value: string | undefined): boolean {
        return !!value && value.trim() !== "";
    }
}